export function isValidUrl(url: string): boolean {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return false;
  }

  if (url.includes('javascript:')) {
    return false;
  }

  return true;
}
